import '@/locales/i18n'
import '@/styles/globals.css'

import React from 'react'
import ReactDOM from 'react-dom/client'

import { App } from './App'

const start = async () => {
  if (import.meta.env.DEV) {
    const VConsole = await import('vconsole').then((m) => m.default)
    new VConsole()
  }

  if (import.meta.env.DEV && import.meta.env.VITE_USE_MOCK === 'true') {
    const { startMockWorker } = await import('@/mocks')
    await startMockWorker()
  }

  ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  )
}

void start()
